import BaseService from './base'

export default class CountryService extends BaseService {
  static resource() {
    //return 'api/v1/external/countries'
    return 'api/v1/countries'
  }
}
